<template>
    <!--  BEGIN SIDEBAR  -->
    <div class="sidebar-wrapper sidebar-theme">
        <nav ref="menu" id="sidebar">
            <div class="shadow-bottom"></div>

            <perfect-scrollbar class="list-unstyled menu-categories" tag="ul" :options="{ wheelSpeed: 0.5, swipeEasing: !0, minScrollbarLength: 40, maxScrollbarLength: 300, suppressScrollX: true }">
                <li class="menu" v-for="menu in store.getters.getMenuTree">
                    <router-link :to="menu.url" class="dropdown-toggle" @click="toggleMobileMenu" v-if="singlePages.includes(menu.name)">
                        <div class="">
                            <svg v-if="menu.name === 'Dashboard'"
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-home"
                            >
                                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                                <polyline points="9 22 9 12 15 12 15 22"></polyline>
                            </svg>
                            <svg v-if="['Remote control', 'Tree'].includes(menu.name)"
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-cpu"
                            >
                                <rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect>
                                <rect x="9" y="9" width="6" height="6"></rect>
                                <line x1="9" y1="1" x2="9" y2="4"></line>
                                <line x1="15" y1="1" x2="15" y2="4"></line>
                                <line x1="9" y1="20" x2="9" y2="23"></line>
                                <line x1="15" y1="20" x2="15" y2="23"></line>
                                <line x1="20" y1="9" x2="23" y2="9"></line>
                                <line x1="20" y1="14" x2="23" y2="14"></line>
                                <line x1="1" y1="9" x2="4" y2="9"></line>
                                <line x1="1" y1="14" x2="4" y2="14"></line>
                            </svg>
                            <span>{{ menu.name}}</span>
                        </div>
                    </router-link>
                    <a class="dropdown-toggle" data-bs-toggle="collapse" :data-bs-target="'#' + getIdByName(menu.name)" :aria-controls="getIdByName(menu.name)" aria-expanded="false" v-if="!singlePages.includes(menu.name)">
                        <div class="">
                            <svg v-if="!alterIconPages.includes(menu.name)"
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-users"
                            >
                                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                                <circle cx="9" cy="7" r="4"></circle>
                                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                            </svg>
                            <svg v-if="alterIconPages.includes(menu.name)"
                                 xmlns="http://www.w3.org/2000/svg"
                                 width="24"
                                 height="24"
                                 viewBox="0 0 24 24"
                                 fill="none"
                                 stroke="currentColor"
                                 stroke-width="2"
                                 stroke-linecap="round"
                                 stroke-linejoin="round"
                                 class="feather feather-cpu"
                            >
                                <rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect>
                                <rect x="9" y="9" width="6" height="6"></rect>
                                <line x1="9" y1="1" x2="9" y2="4"></line>
                                <line x1="15" y1="1" x2="15" y2="4"></line>
                                <line x1="9" y1="20" x2="9" y2="23"></line>
                                <line x1="15" y1="20" x2="15" y2="23"></line>
                                <line x1="20" y1="9" x2="23" y2="9"></line>
                                <line x1="20" y1="14" x2="23" y2="14"></line>
                                <line x1="1" y1="9" x2="4" y2="9"></line>
                                <line x1="1" y1="14" x2="4" y2="14"></line>
                            </svg>
                            <span>{{ menu.name }}</span>
                        </div>
                        <div>
                            <svg 
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-chevron-right"
                            >
                                <polyline points="9 18 15 12 9 6"></polyline>
                            </svg>
                        </div>
                    </a>
                    
                    <ul :id="getIdByName(menu.name)" class="collapse submenu list-unstyled" data-bs-parent="#sidebar" v-if="menu.children">
                        <li v-for="item in menu.children">
                            <router-link :to="item.url" @click="toggleMobileMenu">{{ item.name }}</router-link>
                        </li>
                    </ul>
                </li>
                
                
                
                
<!--                <li class="menu">-->
<!--                    <router-link to="/" class="dropdown-toggle" @click="toggleMobileMenu">-->
<!--                        <div class="">-->
<!--                            <svg-->
<!--                                xmlns="http://www.w3.org/2000/svg"-->
<!--                                width="24"-->
<!--                                height="24"-->
<!--                                viewBox="0 0 24 24"-->
<!--                                fill="none"-->
<!--                                stroke="currentColor"-->
<!--                                stroke-width="2"-->
<!--                                stroke-linecap="round"-->
<!--                                stroke-linejoin="round"-->
<!--                                class="feather feather-home"-->
<!--                            >-->
<!--                                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>-->
<!--                                <polyline points="9 22 9 12 15 12 15 22"></polyline>-->
<!--                            </svg>-->
<!--                            <span>{{ $t('dashboard') }}</span>-->
<!--                        </div>-->
<!--                    </router-link>-->
<!--                </li>-->


<!--                <li class="menu">-->
<!--                    <router-link to="/remoteControl" class="dropdown-toggle" @click="toggleMobileMenu">-->
<!--                        <div class="">-->
<!--                            <svg-->
<!--                                xmlns="http://www.w3.org/2000/svg"-->
<!--                                width="24"-->
<!--                                height="24"-->
<!--                                viewBox="0 0 24 24"-->
<!--                                fill="none"-->
<!--                                stroke="currentColor"-->
<!--                                stroke-width="2"-->
<!--                                stroke-linecap="round"-->
<!--                                stroke-linejoin="round"-->
<!--                                class="feather feather-cpu"-->
<!--                            >-->
<!--                                <rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect>-->
<!--                                <rect x="9" y="9" width="6" height="6"></rect>-->
<!--                                <line x1="9" y1="1" x2="9" y2="4"></line>-->
<!--                                <line x1="15" y1="1" x2="15" y2="4"></line>-->
<!--                                <line x1="9" y1="20" x2="9" y2="23"></line>-->
<!--                                <line x1="15" y1="20" x2="15" y2="23"></line>-->
<!--                                <line x1="20" y1="9" x2="23" y2="9"></line>-->
<!--                                <line x1="20" y1="14" x2="23" y2="14"></line>-->
<!--                                <line x1="1" y1="9" x2="4" y2="9"></line>-->
<!--                                <line x1="1" y1="14" x2="4" y2="14"></line>-->
<!--                            </svg>-->
<!--                            <span>{{ $t('remote_control') }}</span>-->
<!--                        </div>-->
<!--                    </router-link>-->
<!--                </li>-->

<!--                <li class="menu">-->
<!--                    <a class="dropdown-toggle" data-bs-toggle="collapse" data-bs-target="#users" aria-controls="users" aria-expanded="false">-->
<!--                        <div class="">-->
<!--                            <svg-->
<!--                                xmlns="http://www.w3.org/2000/svg"-->
<!--                                width="24"-->
<!--                                height="24"-->
<!--                                viewBox="0 0 24 24"-->
<!--                                fill="none"-->
<!--                                stroke="currentColor"-->
<!--                                stroke-width="2"-->
<!--                                stroke-linecap="round"-->
<!--                                stroke-linejoin="round"-->
<!--                                class="feather feather-users"-->
<!--                            >-->
<!--                                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>-->
<!--                                <circle cx="9" cy="7" r="4"></circle>-->
<!--                                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>-->
<!--                                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>-->
<!--                            </svg>-->
<!--                            <span>{{ $t('users') }}</span>-->
<!--                        </div>-->
<!--                        <div>-->
<!--                            <svg-->
<!--                                xmlns="http://www.w3.org/2000/svg"-->
<!--                                width="24"-->
<!--                                height="24"-->
<!--                                viewBox="0 0 24 24"-->
<!--                                fill="none"-->
<!--                                stroke="currentColor"-->
<!--                                stroke-width="2"-->
<!--                                stroke-linecap="round"-->
<!--                                stroke-linejoin="round"-->
<!--                                class="feather feather-chevron-right"-->
<!--                            >-->
<!--                                <polyline points="9 18 15 12 9 6"></polyline>-->
<!--                            </svg>-->
<!--                        </div>-->
<!--                    </a>-->

<!--                    <ul id="users" class="collapse submenu list-unstyled" data-bs-parent="#sidebar">-->
<!--&lt;!&ndash;                        <li>&ndash;&gt;-->
<!--&lt;!&ndash;                            <router-link to="/users/profile" @click="toggleMobileMenu">Profile</router-link>&ndash;&gt;-->
<!--&lt;!&ndash;                        </li>&ndash;&gt;-->
<!--&lt;!&ndash;                        <li>&ndash;&gt;-->
<!--&lt;!&ndash;                            <router-link to="/users/account-setting" @click="toggleMobileMenu">Account Settings</router-link>&ndash;&gt;-->
<!--&lt;!&ndash;                        </li>&ndash;&gt;-->
<!--                        <li>-->
<!--                            <router-link to="/users/create" @click="toggleMobileMenu">{{ $t('create') }}</router-link>-->
<!--                        </li>-->
<!--                        <li>-->
<!--                            <router-link to="/users/list" @click="toggleMobileMenu">{{ $t('search') }}</router-link>-->
<!--                        </li>-->
<!--                        <li>-->
<!--                            <router-link to="/users/roles" @click="toggleMobileMenu">{{ $t('roles') }}</router-link>-->
<!--                        </li> -->
<!--                        <li>-->
<!--                            <router-link to="/users/permissions" @click="toggleMobileMenu">{{ $t('permissions') }}</router-link>-->
<!--                        </li>-->
<!--                    </ul>-->
<!--                </li>-->

<!--                <li class="menu">-->
<!--                    <a class="dropdown-toggle" data-bs-toggle="collapse" data-bs-target="#company" aria-controls="company" aria-expanded="false">-->
<!--                        <div class="">-->
<!--                            <svg-->
<!--                                xmlns="http://www.w3.org/2000/svg"-->
<!--                                width="24"-->
<!--                                height="24"-->
<!--                                viewBox="0 0 24 24"-->
<!--                                fill="none"-->
<!--                                stroke="currentColor"-->
<!--                                stroke-width="2"-->
<!--                                stroke-linecap="round"-->
<!--                                stroke-linejoin="round"-->
<!--                                class="feather feather-users"-->
<!--                            >-->
<!--                                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>-->
<!--                                <circle cx="9" cy="7" r="4"></circle>-->
<!--                                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>-->
<!--                                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>-->
<!--                            </svg>-->
<!--                            <span>{{ $t('company') }}</span>-->
<!--                        </div>-->
<!--                        <div>-->
<!--                            <svg-->
<!--                                xmlns="http://www.w3.org/2000/svg"-->
<!--                                width="24"-->
<!--                                height="24"-->
<!--                                viewBox="0 0 24 24"-->
<!--                                fill="none"-->
<!--                                stroke="currentColor"-->
<!--                                stroke-width="2"-->
<!--                                stroke-linecap="round"-->
<!--                                stroke-linejoin="round"-->
<!--                                class="feather feather-chevron-right"-->
<!--                            >-->
<!--                                <polyline points="9 18 15 12 9 6"></polyline>-->
<!--                            </svg>-->
<!--                        </div>-->
<!--                    </a>-->

<!--                    <ul id="company" class="collapse submenu list-unstyled" data-bs-parent="#company">-->
<!--                         <li>-->
<!--                            <router-link to="/company/create" @click="toggleMobileMenu">{{ $t('create') }}</router-link>-->
<!--                        </li>-->
<!--                        <li>-->
<!--                            <router-link to="/company/list" @click="toggleMobileMenu">{{ $t('search') }}</router-link>-->
<!--                        </li>-->
<!--                    </ul>-->
<!--                </li>-->

<!--                <li class="menu">-->
<!--                    <a class="dropdown-toggle" data-bs-toggle="collapse" data-bs-target="#sites" aria-controls="company" aria-expanded="false">-->
<!--                        <div class="">-->
<!--                            <svg-->
<!--                                xmlns="http://www.w3.org/2000/svg"-->
<!--                                width="24"-->
<!--                                height="24"-->
<!--                                viewBox="0 0 24 24"-->
<!--                                fill="none"-->
<!--                                stroke="currentColor"-->
<!--                                stroke-width="2"-->
<!--                                stroke-linecap="round"-->
<!--                                stroke-linejoin="round"-->
<!--                                class="feather feather-users"-->
<!--                            >-->
<!--                                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>-->
<!--                                <circle cx="9" cy="7" r="4"></circle>-->
<!--                                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>-->
<!--                                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>-->
<!--                            </svg>-->
<!--                            <span>{{ $t('sites') }}</span>-->
<!--                        </div>-->
<!--                        <div>-->
<!--                            <svg-->
<!--                                xmlns="http://www.w3.org/2000/svg"-->
<!--                                width="24"-->
<!--                                height="24"-->
<!--                                viewBox="0 0 24 24"-->
<!--                                fill="none"-->
<!--                                stroke="currentColor"-->
<!--                                stroke-width="2"-->
<!--                                stroke-linecap="round"-->
<!--                                stroke-linejoin="round"-->
<!--                                class="feather feather-chevron-right"-->
<!--                            >-->
<!--                                <polyline points="9 18 15 12 9 6"></polyline>-->
<!--                            </svg>-->
<!--                        </div>-->
<!--                    </a>-->

<!--                    <ul id="sites" class="collapse submenu list-unstyled" data-bs-parent="#sites">-->
<!--                        <li>-->
<!--                            <router-link to="/sites/create" @click="toggleMobileMenu">{{ $t('create') }}</router-link>-->
<!--                        </li>-->
<!--                        <li>-->
<!--                            <router-link to="/sites/list" @click="toggleMobileMenu">{{ $t('search') }}</router-link>-->
<!--                        </li>-->
<!--                    </ul>-->
<!--                </li>-->

<!--                <li class="menu">-->
<!--                    <a class="dropdown-toggle" data-bs-toggle="collapse" data-bs-target="#systems" aria-controls="systems" aria-expanded="false">-->
<!--                        <div class="">-->
<!--                            <svg-->
<!--                                xmlns="http://www.w3.org/2000/svg"-->
<!--                                width="24"-->
<!--                                height="24"-->
<!--                                viewBox="0 0 24 24"-->
<!--                                fill="none"-->
<!--                                stroke="currentColor"-->
<!--                                stroke-width="2"-->
<!--                                stroke-linecap="round"-->
<!--                                stroke-linejoin="round"-->
<!--                                class="feather feather-users"-->
<!--                            >-->
<!--                                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>-->
<!--                                <circle cx="9" cy="7" r="4"></circle>-->
<!--                                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>-->
<!--                                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>-->
<!--                            </svg>-->
<!--                            <span>{{ $t('systems') }}</span>-->
<!--                        </div>-->
<!--                        <div>-->
<!--                            <svg-->
<!--                                xmlns="http://www.w3.org/2000/svg"-->
<!--                                width="24"-->
<!--                                height="24"-->
<!--                                viewBox="0 0 24 24"-->
<!--                                fill="none"-->
<!--                                stroke="currentColor"-->
<!--                                stroke-width="2"-->
<!--                                stroke-linecap="round"-->
<!--                                stroke-linejoin="round"-->
<!--                                class="feather feather-chevron-right"-->
<!--                            >-->
<!--                                <polyline points="9 18 15 12 9 6"></polyline>-->
<!--                            </svg>-->
<!--                        </div>-->
<!--                    </a>-->

<!--                    <ul id="systems" class="collapse submenu list-unstyled" data-bs-parent="#systems">-->
<!--                        <li>-->
<!--                            <router-link to="/systems/create" @click="toggleMobileMenu">{{ $t('create') }}</router-link>-->
<!--                        </li>-->
<!--                        <li>-->
<!--                            <router-link to="/systems/list" @click="toggleMobileMenu">{{ $t('search') }}</router-link>-->
<!--                        </li>-->
<!--                    </ul>-->
<!--                </li>-->
<!--                -->
<!--                &lt;!&ndash;Diagnostic tools&ndash;&gt;-->
<!--                <li class="menu">-->
<!--                    <a class="dropdown-toggle" data-bs-toggle="collapse" data-bs-target="#diagnostic" aria-controls="diagnostic" aria-expanded="false">-->
<!--                        <div class="">-->
<!--                            <svg-->
<!--                                xmlns="http://www.w3.org/2000/svg"-->
<!--                                width="24"-->
<!--                                height="24"-->
<!--                                viewBox="0 0 24 24"-->
<!--                                fill="none"-->
<!--                                stroke="currentColor"-->
<!--                                stroke-width="2"-->
<!--                                stroke-linecap="round"-->
<!--                                stroke-linejoin="round"-->
<!--                                class="feather feather-cpu"-->
<!--                            >-->
<!--                                <rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect>-->
<!--                                <rect x="9" y="9" width="6" height="6"></rect>-->
<!--                                <line x1="9" y1="1" x2="9" y2="4"></line>-->
<!--                                <line x1="15" y1="1" x2="15" y2="4"></line>-->
<!--                                <line x1="9" y1="20" x2="9" y2="23"></line>-->
<!--                                <line x1="15" y1="20" x2="15" y2="23"></line>-->
<!--                                <line x1="20" y1="9" x2="23" y2="9"></line>-->
<!--                                <line x1="20" y1="14" x2="23" y2="14"></line>-->
<!--                                <line x1="1" y1="9" x2="4" y2="9"></line>-->
<!--                                <line x1="1" y1="14" x2="4" y2="14"></line>-->
<!--                            </svg>-->
<!--                            <span>{{ $t('diagnostic') }}</span>-->
<!--                        </div>-->
<!--                        <div>-->
<!--                            <svg-->
<!--                                xmlns="http://www.w3.org/2000/svg"-->
<!--                                width="24"-->
<!--                                height="24"-->
<!--                                viewBox="0 0 24 24"-->
<!--                                fill="none"-->
<!--                                stroke="currentColor"-->
<!--                                stroke-width="2"-->
<!--                                stroke-linecap="round"-->
<!--                                stroke-linejoin="round"-->
<!--                                class="feather feather-chevron-right"-->
<!--                            >-->
<!--                                <polyline points="9 18 15 12 9 6"></polyline>-->
<!--                            </svg>-->
<!--                        </div>-->
<!--                    </a>-->

<!--                    <ul id="diagnostic" class="collapse submenu list-unstyled" data-bs-parent="#diagnostic">-->
<!--                        <li>-->
<!--                            <router-link to="/diagnostic/unit" @click="toggleMobileMenu">{{ $t('diagnostic-unit') }}</router-link>-->
<!--                        </li>-->
<!--                    </ul>-->
<!--                </li>-->
<!--                -->
<!--                &lt;!&ndash;Alert notification&ndash;&gt;-->
<!--                <li class="menu">-->
<!--                    <a class="dropdown-toggle" data-bs-toggle="collapse" data-bs-target="#alert" aria-controls="alert" aria-expanded="false">-->
<!--                        <div class="">-->
<!--                            <svg-->
<!--                                xmlns="http://www.w3.org/2000/svg"-->
<!--                                width="24"-->
<!--                                height="24"-->
<!--                                viewBox="0 0 24 24"-->
<!--                                fill="none"-->
<!--                                stroke="currentColor"-->
<!--                                stroke-width="2"-->
<!--                                stroke-linecap="round"-->
<!--                                stroke-linejoin="round"-->
<!--                                class="feather feather-cpu"-->
<!--                            >-->
<!--                                <rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect>-->
<!--                                <rect x="9" y="9" width="6" height="6"></rect>-->
<!--                                <line x1="9" y1="1" x2="9" y2="4"></line>-->
<!--                                <line x1="15" y1="1" x2="15" y2="4"></line>-->
<!--                                <line x1="9" y1="20" x2="9" y2="23"></line>-->
<!--                                <line x1="15" y1="20" x2="15" y2="23"></line>-->
<!--                                <line x1="20" y1="9" x2="23" y2="9"></line>-->
<!--                                <line x1="20" y1="14" x2="23" y2="14"></line>-->
<!--                                <line x1="1" y1="9" x2="4" y2="9"></line>-->
<!--                                <line x1="1" y1="14" x2="4" y2="14"></line>-->
<!--                            </svg>-->
<!--                            <span>{{ $t('alert-notification') }}</span>-->
<!--                        </div>-->
<!--                        <div>-->
<!--                            <svg-->
<!--                                xmlns="http://www.w3.org/2000/svg"-->
<!--                                width="24"-->
<!--                                height="24"-->
<!--                                viewBox="0 0 24 24"-->
<!--                                fill="none"-->
<!--                                stroke="currentColor"-->
<!--                                stroke-width="2"-->
<!--                                stroke-linecap="round"-->
<!--                                stroke-linejoin="round"-->
<!--                                class="feather feather-chevron-right"-->
<!--                            >-->
<!--                                <polyline points="9 18 15 12 9 6"></polyline>-->
<!--                            </svg>-->
<!--                        </div>-->
<!--                    </a>-->

<!--                    <ul id="alert" class="collapse submenu list-unstyled" data-bs-parent="#diagnostic">-->
<!--                        <li>-->
<!--                            <router-link to="/alert-notification/alert" @click="toggleMobileMenu">{{ $t('alert') }}</router-link>-->
<!--                        </li>-->
<!--                        <li>-->
<!--                            <router-link to="/alert-notification/notification-list" @click="toggleMobileMenu">{{ $t('notification-list') }}</router-link>-->
<!--                        </li>-->
<!--                    </ul>-->
<!--                </li>-->
                
            </perfect-scrollbar>
        </nav>
    </div>
    <!--  END SIDEBAR  -->
</template>

<script setup>
    import { onMounted, ref } from 'vue';
    import { useStore } from 'vuex';
    const store = useStore();
    const singlePages = ref(['Dashboard', 'Remote control', 'Tree'])
    const alterIconPages = ref(['diagnostic','Alert notification', 'Tree'])

    const menu_collapse = ref('dashboard');

    onMounted(async () => {
        await store.dispatch('fetchGetMenuTree')
        console.log('menu', store.getters.getMenuTree)
        const selector = document.querySelector('#sidebar a[href="' + window.location.pathname + '"]');
        if (selector) {
            const ul = selector.closest('ul.collapse');
            if (ul) {
                let ele = ul.closest('li.menu').querySelectorAll('.dropdown-toggle');
                if (ele) {
                    ele = ele[0];
                    setTimeout(() => {
                        ele.click();
                    });
                }
            } else {
                selector.click();
            }
        }
    });
    const getIdByName = (name) =>{
        return name.replace(" ", '')
    }

    const toggleMobileMenu = () => {
        if (window.innerWidth < 991) {
            store.commit('toggleSideBar', !store.state.is_show_sidebar);
        }
    };
</script>
